import { useEffect, useMemo, useState } from "react";
import { Api } from "../../api/api";
import { HostedTool } from "./HostedTools.types";

const GROUP_ORDER = [
  "Connector tool",
  "Search widget",
  "Search profiles widget",
  "Other",
];

export const useHostedTools = () => {
  const [tools, setTools] = useState<HostedTool[]>([]);
  const [query, setQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await Api.getHostedTools();
        if (!cancelled) {
          setTools(response.data);
        }
      } catch {
        if (!cancelled) {
          setError("Could not load hosted tools from the demo storage account.");
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  const groups = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    const filtered = tools.filter((tool) => {
      if (!normalizedQuery) {
        return true;
      }

      return [tool.group, tool.name, tool.path]
        .join(" ")
        .toLowerCase()
        .includes(normalizedQuery);
    });

    return GROUP_ORDER.map((group) => ({
      group,
      tools: filtered.filter((tool) => tool.group === group),
    })).filter((section) => section.tools.length > 0);
  }, [query, tools]);

  const visible = groups.reduce((count, section) => count + section.tools.length, 0);

  return {
    groups,
    query,
    setQuery,
    isLoading,
    error,
    total: tools.length,
    visible,
  };
};
